//store.js
import Vue from 'vue';

export let store = Vue.observable({
    openid: "0",
    tokenPhone:false,
});
export let mutations = {
    getOpenid(msg) {
        store.openid = msg;
    },
    getToken(msg) {
        store.tokenPhone = msg;
    },
}